import { ProjectPageHeader } from "@/components/project/project-page-header";
import { ProjectPage } from "@/components/project/project-page";
import { ProjectAbout } from "@/components/project/project-about";
import { ProjectApprovalSettings } from "@/components/project/project-approval-settings";
import { ProjectDeleteDialog } from "@/components/project/project-delete-dialog";
import { ProjectEnvironments } from "@/components/project/project-environments";
import { ProjectUpdateForm } from "@/components/project/project-update-form";
import { orpc } from "@/lib/orpc";
import { Button } from "@papier/ui/components/ui/button";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { TrashBinTrash as Trash2 } from "@papier/ui/components/icons";
import { useState } from "react";
import { SettingsSection } from "@papier/ui/components/ui/settings-section";
import { DestructiveActionCard } from "@papier/ui/components/ui/destructive-action-card";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data: project } = useSuspenseQuery(
    orpc.projects.getBySlug.queryOptions({
      input: params,
      ...{
        select: (data) => ({
          id: data.id,
          name: data.name,
          slug: data.slug,
        }),
      },
    }),
  );
  const [isDelete, setIsDelete] = useState(false);

  return (
    <ProjectPage>
      <ProjectPageHeader
        title="Project settings"
        description="Manage project details, publishing rules, and environments."
      />
      <div className="space-y-8 sm:space-y-10">
        <SettingsSection
          id="project-details"
          title="Project details"
          description="The name, icon, and default languages your team sees."
        >
          <ProjectUpdateForm projectSlug={project.slug} />
        </SettingsSection>
        <SettingsSection
          id="project-publishing"
          title="Publishing"
          description="Choose how templates are reviewed before they go live."
        >
          <ProjectApprovalSettings projectId={project.id} />
        </SettingsSection>
        <SettingsSection
          id="project-environments"
          title="Environments"
          description="Separate template versions for each stage of development."
        >
          <ProjectEnvironments projectSlug={project.slug} />
        </SettingsSection>
        <ProjectAbout projectSlug={project.slug} />
        <SettingsSection
          id="project-danger-zone"
          title="Danger zone"
          description="Permanent actions that affect everyone in this project."
        >
          <DestructiveActionCard
            title="Delete project"
            description={`Permanently delete ${project.name} and all its templates. This cannot be undone.`}
            action={
              <ProjectDeleteDialog
                open={isDelete}
                projectId={project.id}
                setOpen={setIsDelete}
                trigger={
                  <Button variant="destructive-outline">
                    <Trash2 className="size-4" aria-hidden="true" />
                    Delete project
                  </Button>
                }
              />
            }
          />
        </SettingsSection>
      </div>
    </ProjectPage>
  );
}
